export const getViewAsMode = (search = window.location.search) => {
  const mode = new URLSearchParams(search).get('viewAs');
  if (mode === 'public' || mode === 'citizen') return mode;
  return null;
};

export const isPublicViewMode = (search = window.location.search) => getViewAsMode(search) === 'public';
